import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Offline shell for the installable PWA. Not registered inside the Android app (assets are bundled there).
if ('serviceWorker' in navigator && import.meta.env.PROD && !(globalThis as { Capacitor?: unknown }).Capacitor) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${import.meta.env.BASE_URL}sw.js`).catch(() => undefined);
  });
}
